import React, { useState, useEffect } from 'react';
import { KFLDialog } from '@kamstrup/kamstrup-frontend-library';
import { useSelector } from 'react-redux';
import Translate from '../shared/localization/localize';
import DialogHeader from '../shared/dialog/dialogHeader';
import { ReduxState } from '../../interfaces';
import DeviceInfoItemDetails from './deviceInfoDetails';
import * as Devices from '../../modules/devices';
import * as DeviceInfo from '../../modules/dialogs/deviceInfo';
import DialogSection from '../shared/dialog/dialogSection';
import { Historical } from '../../modules/historical/context';
import {
  mapLog,
  getMoreLogs,
  getLatestLogs,
} from '../../modules/dialogs/deviceInfo';
import LogMappedList from '../shared/historical/LogMappedList';
import useDialog from '../shared/dialog/useDialog';

const DeviceLogsDialog: React.FC = () => {
  const {setDialog} = useDialog();
  const { deviceKey, items } = useSelector(
    (s: ReduxState) => s.dialogState.deviceInfoDialog
  );
  const { data: devicesData } = useSelector((s: ReduxState) => s.devicesState);

  const [item, setItem] = useState(undefined as DeviceInfo.Item | undefined);

  useEffect(() => {
    setItem(DeviceInfo.getItem(deviceKey, items, devicesData));
  }, [deviceKey, items, devicesData]);

  if (!item) return <></>;

  const getLatest = () => getLatestLogs(item);
  const getMore = () => getMoreLogs(item);

  const sections = (
    <>
      <DialogSection>
        <DeviceInfoItemDetails
          key="dialog-devicelogs-id"
          item={item}
          isLoading={item.getInfoCall.isFetching}
          onlyBasic
        />
      </DialogSection>
      <DialogSection isMain scrollable>
        <Historical<Devices.Log>
          value={{
            historical: item.historicalLogs,
            getLatestLogs: getLatest,
            getMoreLogs: getMore,
          }}
        >
          <LogMappedList mapLog={mapLog}></LogMappedList>
        </Historical>
      </DialogSection>
    </>
  );

  return (
    <KFLDialog
      header={
        <DialogHeader
          title={<Translate message={DeviceInfo.msgLogsHeader} />}
          fnCloseDialog={() => setDialog?.()}
          fnBackDialog={() => DeviceInfo.initDialog(Devices.getPK(item))}
        />
      }
      sections={[sections]}
    />
  );
};

export default DeviceLogsDialog;
